import { Shark, Utils, View } from "shark-mvc";
import $ from "jquery";
import moment from "moment";
import Papa from "papaparse";

import templateContent from "./lead-import.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import leadListView from "./leadListView";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import { informationModalComponent } from "../../components/informationModal/informationModalComponent";

class LeadImportView extends View {
	constructor(name) {
		super(name);

		this.setTemplate(templateContent);
	}
	
	beforeLoad () {
		if (!Shark.get("userList") || Shark.get("userList").length === 0) {
			userManager.getList();
		}

		this.set({
			__showClientTable: false,
			__showImportForm: true,
			__showPreviewTable: false,
		});

		Shark.set({
			prospectCSVSource: "",
			prospectImportPreviewData: null,
			prospectToImportList: null,
		}); 
	}

	customCSVFile_changeHandler (event) {
		waitBoxComponent.show();
		console.log(event.target.files);

		Papa.parse(event.target.files[0], {
			beforeFirstChunk: (chunk) => {
				return chunk.substr(chunk.indexOf("\n") + 1);
			},
			complete: (results, file) => {
				console.log({results, file});

				this.populateColumns(results.data);

				waitBoxComponent.hide();
			},
			encoding: "ISO-8859-1",
			header: false,
			skipEmptyLines: "greedy",
		});
		// const reader = new FileReader();
		// reader.addEventListener('load', (event) => {
		// 	console.log({event})
		// 	const csvTextArea = document.querySelector("#csvTextArea");

		// 	if (csvTextArea) {
		// 		csvTextArea.innerHTML = event.target.result;
		// 	}

		// 	waitBoxComponent.hide();
		// });
		// reader.readAsText(event.target.files[0], "ISO-8859-1");
	}

	init () {
		this.addComponents([mainNavComponent, informationModalComponent, waitBoxComponent]);

		const importSettings = Shark.getInstance("__smart__", {
			preset: "hubspot"
		});

		this.set({
			__showImportForm: true,
			__showPreviewTable: false,
		}); 
		Shark.set({
			importSettings,
			prospectCSVSource: "",
			prospectImportPreviewData: null,
			prospectToImportList: null,
		}); 	
	}

	leadImportSelectAllChk_changeHandler (event) {
		document.querySelectorAll(".leadImportChks").forEach(item => item.checked = event.target.checked);
		const prospectToImportList = Shark.get("prospectToImportList");
		prospectToImportList.forEach(item => item.set("__selectedForImport", event.target.checked));
	}

	populateColumns (prospectImportPreviewData) {
		const prospectSource = document.querySelector("#prospectSourceField").value;
		const prospectFairSource = document.querySelector("#prospectFairSourceField").value;

		const importSettings = Shark.get("importSettings");
		console.log({importSettings, prospectImportPreviewData});

		if (prospectImportPreviewData.length > 0) {
			let prospectImportFieldAssignment;
			let fieldNames;

			switch (importSettings.preset) {
				case "hubspot":
					fieldNames = ["leadRequestDate", "autoContactSource", "autoContactSourceDetails", "contactPersonFirstName", "contactPersonLastName", "email", "leadIncomingMessage", "leadRequestedArea", "phone", "province", "leadInterestSolutions", "businessDescription", "name", "referenceAgentName"];
					prospectImportFieldAssignment = prospectImportPreviewData[0].map((item, index) => {
						return Shark.getInstance("__smart__", {
							fieldIndex: index,
							fieldName: fieldNames[index],
						});
					});
					break;
				case "hubspotShort":
					fieldNames = ["contactPersonFirstName", "contactPersonLastName", "email", "leadIncomingMessage", "leadRequestedArea", "phone", "province", "leadInterestSolutions", "businessDescription", "name", "referenceAgentName"];
					prospectImportFieldAssignment = prospectImportPreviewData[0].map((item, index) => {
						return Shark.getInstance("__smart__", {
							fieldIndex: index,
							fieldName: fieldNames[index],
						});
					});
					break;
				default:
					prospectImportFieldAssignment = prospectImportPreviewData[0].map((item, index) => {
						return Shark.getInstance("__smart__", {
							fieldIndex: index,
							fieldName: ""
						});
					});
					break;
			}
			
			console.log({ prospectImportPreviewData, prospectImportFieldAssignment });

			this.set({
				__showImportForm: false,
				__showPreviewTable: true,
			});
			Shark.set({
				prospectFairSourceValue: prospectFairSource,
				prospectSourceValue: prospectSource,
				// prospectCSVSource: csvSource,
				prospectImportFieldAssignment,
				prospectImportPreviewData
			});
		}
	}
	
	processCSVTextBtn_clickHandler () {
		const csvTextArea = document.querySelector("#csvTextArea");
		const csvSource = csvTextArea.value.trim();
		const prospectSource = document.querySelector("#prospectSourceField").value;
		const prospectFairSource = document.querySelector("#prospectFairSourceField").value;
		
		// if (prospectSource == 0) {
		// 	alert("Per favore indica da dove arrivano i contatti");
		// 	return;
		// }

		if (csvSource !== "") {
			return;
			// const rows = csvSource.split("\n");
			// const prospectImportPreviewData = rows.map(item => item.split(";").map(field => field.trim()));
			// // const prospectImportPreviewData = rows.map(item => item.split("\t").map(field => field.trim()));

			// if (prospectImportPreviewData.length > 0) {
			// 	const prospectImportFieldAssignment = prospectImportPreviewData[0].map((item, index) => {
			// 		return Shark.getInstance(null, {
			// 			fieldIndex: index,
			// 			fieldName: ""
			// 		});
			// 	});
				
			// 	console.log({ rows, prospectImportPreviewData, prospectImportFieldAssignment });

			// 	this.set({
			// 		__showImportForm: false,
			// 		__showPreviewTable: true,
			// 	});
			// 	Shark.set({
			// 		prospectFairSourceValue: prospectFairSource,
			// 		prospectSourceValue: prospectSource,
			// 		prospectCSVSource: csvSource,
			// 		prospectImportFieldAssignment,
			// 		prospectImportPreviewData
			// 	});
			// }
		}
		else {
			alert("Attenzione, non ci sono dati da processare.");
		}
	}




		
	backToDataInsertBtn_clickHandler () {
		this.set({
			__showClientTable: false,
			__showImportForm: true,
			__showPreviewTable: false,
		});
		this.render();
	}

	backToFieldAssignmentBtn_clickHandler () {
		this.set({
			__showClientTable: false,
			__showImportForm: false,
			__showPreviewTable: true,
		});
		this.render();
	}

	confirmAndImportBtn_clickHandler () {
		const prospectToImportList = Shark.get("prospectToImportList");
		if (prospectToImportList.length > 0) {
			const prospectSelectedList = prospectToImportList.filter(item => item.__selectedForImport);
			console.log({prospectToImportList, prospectSelectedList})
			
			if (prospectSelectedList.length > 0 && confirm(`Sei sicuro di voler importare i ${prospectSelectedList.length} contatti selezionati di questa lista?\nSe prosegui non sarà possibile annullare.`)) {
				clientManager.saveProspectList(prospectSelectedList)
				.then(saveProspectListResponse => {
					prospectToImportList.forEach(item => {
						if (item.extraData.leadIncomingMessage.trim() !== "") {
							const newFollowUp = Shark.getInstance("ClientFollowUp", {
								body: item.extraData.leadIncomingMessage.trim(),
								clientGuid: item.guid,
								referenceGuid: item.guid,
								referenceType: "client",
								status: 3,
								type: "leadIncomingMessage"
							});
							
							followUpManager.save(newFollowUp)
							.then(followUpSaveResponse => {
								item.addFollowUp(newFollowUp);
								console.log({followUpSaveResponse});
							});
						}
					});

					Shark.set("forceProspectListRefresh", true);
					Shark.openPage(leadListView);
				});
			}
			else {
				informationModalComponent.show({body: "Non hai selezionato alcun contatto da importare.", title: "Avviso"});
			}
		}
	}

	confirmFieldAssignmentBtn_clickHandler () {
		const prospectImportFieldAssignment = Shark.get("prospectImportFieldAssignment");
		const prospectImportPreviewData = Shark.get("prospectImportPreviewData");
		const currUser = Shark.get("currUser");
		const prospectSource = Shark.get("prospectSourceValue");
		const prospectFairSource = Shark.get("prospectFairSourceValue");
		const contactSourceList = Shark.get("contactSourceList");

		const [contactSourceDetailList, contactSourceDetailMap, contactSourceDetailLabelMap, importSettings, userList] = Shark.get(["contactSourceDetailList", "contactSourceDetailMap", "contactSourceDetailLabelMap", "importSettings", "userList"]);

		userList.forEach(item => {
			item.__testName = (item.firstName + item.lastName).toLowerCase();
		});

		const prospectToImportList = prospectImportPreviewData.map((prospectRow, prospectIndex) => {
			const prospectData = {
				activityStatus: 1,
				contactPerson: "",
				contactSource: prospectSource,
				createdByGuid: currUser.guid,
				enabled: true,
				extraData: {},
				status: 3,
				__displayIndex: prospectIndex + 1,
				__index: prospectIndex,
				__missingContactSource: false,
			};

			switch (importSettings.preset) {
				case "hubspot":
					prospectData.contactSource = "8";
					prospectData.extraData.contactSourceDetailId = 3;
					break;
			}

			prospectImportFieldAssignment.forEach(matchField => {
				if (matchField.fieldName !== "") {
					if (prospectData.hasOwnProperty(matchField.fieldName)) {
						prospectData[matchField.fieldName] += " " + prospectRow[matchField.fieldIndex];
					}
					else {
						switch (matchField.fieldName) {
							case "autoContactSource": {
								let validContactSource = contactSourceList.find(item => {item.label.toLowerCase() === prospectRow[matchField.fieldIndex].toLowerCase()});
								const validContactSourceDetail = contactSourceDetailList.find(item => item.label.toLowerCase() === prospectRow[matchField.fieldIndex].toLowerCase());

								if (validContactSource) {
									prospectData.contactSource = validContactSource.id;
								}
								else if (validContactSourceDetail) {
									validContactSource = Utils.safp(contactSourceList, "id", validContactSourceDetail.contactSourceId);
									prospectData.contactSource = validContactSource.id;
									prospectData.extraData.contactSourceDetailId = validContactSourceDetail.id;
								}
								else {
									prospectData.extraData.leadRequestSourcePage = prospectRow[matchField.fieldIndex];
								}

								break;
							}
							case "autoContactSourceDetails":
								// const validContactSourceDetail = contactSourceDetailList.find(item => item.label.toLowerCase() === prospectRow[matchField.fieldIndex].toLowerCase());
								prospectData.extraData.leadRequestTrafficType = prospectRow[matchField.fieldIndex];
								break;
							case "contactPersonFirstName":
								prospectData.contactPerson = prospectRow[matchField.fieldIndex] + " " + prospectData.contactPerson.trim();
								break;
							case "contactPersonLastName":
								prospectData.contactPerson = prospectData.contactPerson.trim() + " " + prospectRow[matchField.fieldIndex];
								break;
							case "contactSourceDetailId": {
								const contactSourceDetail = contactSourceDetailLabelMap[prospectRow[matchField.fieldIndex].toLowerCase()];
								if (contactSourceDetail) {
									prospectData.extraData[matchField.fieldName] = contactSourceDetail.id;
									prospectData.contactSource = contactSourceDetail.contactSourceId.toString();
								}
								else {
									prospectData.__missingContactSource = true;
								}
								break;
							}
							case "leadRequestDate": {
								let date = moment(prospectRow[matchField.fieldIndex], "DD/MM/YYYY");

								if (!date.isValid()) {
									date = moment(prospectRow[matchField.fieldIndex]);
								}
								prospectData.extraData[matchField.fieldName] = date;
								break;
							}
							case "leadInterestSolutions": {
								const importValue = prospectRow[matchField.fieldIndex].trim();
								if (importValue !== "" && importValue.length > 2) {
									const values = importValue.split(";");
									const outputValue = new Set();

									values.forEach(item => {
										switch (item.trim()) {
											case "CLS":
											case "Pavimenti in calcestruzzo":
												outputValue.add(3);
												break;
											case "Riqualificazione Pavimenti":
												outputValue.add(2);
												break;
											case "Pavimentazione drenante in graniglia":
												outputValue.add(4);
												break;
											case "Pavimenti in resina":
												outputValue.add(1);
												break;
											case "Prodotti per il trattamento di strade naturali":
												outputValue.add(6);
												break;
											case "Pavimentazioni per aree ludiche e sportive":
												outputValue.add(5);
												break;
											case "Pavimentazioni per la marina":
												outputValue.add(7);
												break;
										}
									});

									prospectData.extraData[matchField.fieldName] = Array.from(outputValue);
								}
								break;
							}
							case "businessDescription":
							case "leadIncomingMessage":
							case "leadRequestedArea":
							case "line":
							case "qualifications":
								prospectData.extraData[matchField.fieldName] = prospectRow[matchField.fieldIndex];
								break;
							case "referenceAgentName": {
								const testName = prospectRow[matchField.fieldIndex].replace(/ /g, "").toLowerCase();
								console.log(testName);
								const agent = Utils.safp(userList, "__testName", testName);

								if (agent) {
									//Dave: bisognerebbe fare un FU che dica che è stato assegnato all'agente
									prospectData.referenceAgentsGuids = [agent.guid];
								}
								break;
							}
							default:
								prospectData[matchField.fieldName] = prospectRow[matchField.fieldIndex];
								break;
						}
					}
				}
			});

			if (prospectData.name.trim() === "") {
				prospectData.name = prospectData.contactPerson;
			}

			if (prospectData.extraData.businessDescription === "Privato") {
				prospectData.extraData.isIndividual = true;
			}

			const newClient = Shark.getInstance("Client", prospectData);
			newClient.__selectedForImport = true;
			newClient.__missingContactSource = prospectData.__missingContactSource;

			if (prospectFairSource !== "") {
				newClient.extraData.sourceFair = prospectFairSource;
			}

			return newClient;
		});

		console.log({ prospectImportPreviewData, prospectImportFieldAssignment, prospectToImportList });

		this.set({
			__showClientTable: true,
			__showImportForm: false,
			__showPreviewTable: false,
		});
		Shark.set({
			prospectToImportList
		});
	}

	prospectSourceField_changeHandler () {
		const prospectSourceField = document.querySelector("#prospectSourceField");
		const prospectFairSourceBox = document.querySelector("#prospectFairSourceBox");

		if (prospectSourceField) {
			if (parseInt(prospectSourceField.value) === 2) {
				prospectFairSourceBox.classList.add("d-block");
				prospectFairSourceBox.classList.remove("d-none");
			}
			else {
				prospectFairSourceBox.classList.remove("d-block");
				prospectFairSourceBox.classList.add("d-none");
			}
		}
	}
}

const leadImportView = new LeadImportView("leadImportView");

Shark.registerView(leadImportView);

export default leadImportView;
